'use strict';

var icon = require('../../../../../../../../../../_virtual/icon3.cjs');

(function (exports) {

	exports.IconVariants = void 0;
	(function(IconVariants) {
	    IconVariants["generic"] = "generic";
	    IconVariants["circular"] = "circular";
	    IconVariants["roundedBox"] = "roundedBox";
	})(exports.IconVariants || (exports.IconVariants = {}));
	
} (icon.__exports));
//# sourceMappingURL=icon.cjs.map
